<main-layout>
  <div class="w-full min-h-[20rem] flex items-center justify-center" v-if="isLoading">
    <Spinner :visible="isLoading" />
  </div>
  <Sections v-else :type="getCurrentCategory"></Sections>
</main-layout>